import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "donut-chart-container" };
const _hoisted_2 = {
    key: 1,
    class: "no-data"
};
import { computed } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent } from 'echarts/components';
import VChart from 'vue-echarts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpendingDonutChart',
    props: {
        categoryTotals: {},
        formatter: {},
        colourMode: { default: 'light' }
    },
    emits: ["category-click"],
    setup(__props, { emit: __emit }) {
        use([CanvasRenderer, PieChart, TooltipComponent, LegendComponent]);
        const props = __props;
        const emit = __emit;
        const totalSpend = computed(() => {
            return props.categoryTotals
                .filter((c) => c.id !== 0)
                .reduce((sum, c) => sum + c.value, 0);
        });
        const chartOption = computed(() => {
            if (!props.categoryTotals || props.categoryTotals.length === 0)
                return null;
            const spendCategories = props.categoryTotals.filter((c) => c.id !== 0 && c.value > 0);
            if (spendCategories.length === 0)
                return null;
            const textColor = props.colourMode === 'dark' ? '#e0e0e0' : '#333';
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        return `${params.name}: ${props.formatter.format(params.value)} (${params.percent}%)`;
                    }
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    textStyle: { color: textColor }
                },
                series: [
                    {
                        name: 'Spending',
                        type: 'pie',
                        radius: ['50%', '75%'],
                        center: ['35%', '50%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 4,
                            borderColor: props.colourMode === 'dark' ? '#1e1e1e' : '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            position: 'center',
                            formatter: () => {
                                return `{total|${props.formatter.format(totalSpend.value)}}\n{label|Total Spend}`;
                            },
                            rich: {
                                total: {
                                    fontSize: 22,
                                    color: textColor,
                                    lineHeight: 30
                                },
                                label: {
                                    fontSize: 12,
                                    color: props.colourMode === 'dark' ? '#999' : '#666'
                                }
                            }
                        },
                        emphasis: {
                            label: { show: true }
                        },
                        labelLine: { show: false },
                        data: spendCategories.map((cat) => ({
                            value: cat.value,
                            name: cat.name,
                            itemStyle: { color: cat.colour },
                            categoryId: cat.id
                        }))
                    }
                ]
            };
        });
        function handleClick(params) {
            if (params.data?.categoryId !== undefined) {
                emit('category-click', params.data.categoryId);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (chartOption.value)
                    ? (_openBlock(), _createBlock(_unref(VChart), {
                        key: 0,
                        ref: "chart",
                        option: chartOption.value,
                        style: { height: '280px', width: '100%' },
                        autoresize: "",
                        onClick: handleClick
                    }, null, 8, ["option"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, "No data available"))
            ]));
        };
    }
});
